import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "@wix/form-fields";
import { Error } from "@wix/wix-ui-icons-common/on-stage";
import { TRANSLATIONS_NAMESPACE } from "../../constants/translations.js";
import { DATA_HOOKS } from "../../tpa/widget/data-hooks.js";
import styles from "./submit-status-message.module.scss";
const ERROR_MESSAGE_KEY = "submit.failed.message";
const SubmitErrorMessage = ({
  errorMessageCode,
  errorMessage
}) => {
  const { t, i18n } = useTranslation();
  if (!errorMessageCode && !errorMessage) {
    return null;
  }
  const errorMessageKeyByCode = `${ERROR_MESSAGE_KEY}.${errorMessageCode}`;
  const errorMessageKey = i18n.exists(
    `${TRANSLATIONS_NAMESPACE}:${errorMessageKeyByCode}`
  ) ? errorMessageKeyByCode : ERROR_MESSAGE_KEY;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles.errorMessage,
      "data-hook": DATA_HOOKS.SUBMIT_ERROR_MESSAGE,
      children: [
        /* @__PURE__ */ jsx(Error, { className: styles.errorIcon, "aria-hidden": "true" }),
        errorMessage || t(errorMessageKey)
      ]
    }
  );
};
export {
  SubmitErrorMessage
};
//# sourceMappingURL=submit-error-message.js.map
